import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { urlLogin } from 'src/app/common';

//const AUTH_API = 'http://localhost:4000/api/v1/auth/';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable({
  providedIn: 'root'
})

/* Este servicio envía solicitudes HTTP POST de registro e inicio de sesión al back-end. */

export class AuthService {

  constructor(private http: HttpClient) { }

  login(email: string, pass: string): Observable<any> {
    return this.http.post(urlLogin + '/login', {
      email,
      pass
    }, httpOptions);
  }  
}
